import { render, staticRenderFns } from "./ServidorMovil.vue?vue&type=template&id=b9ed2380&"
import script from "@/Servicios/ServidorMovil.js?vue&type=script&lang=js&"
export * from "@/Servicios/ServidorMovil.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports